<ng-container *ngIf="translatedValues?.length; else noValueSpecified">
  <nz-tag *ngFor="let option of translatedValues"
          title="{{prefix}}{{option}}"
          [class]="tagClass" [nzColor]="nzColor">{{prefix}}{{option}}</nz-tag>
</ng-container>
<ng-template #noValueSpecified>{{placeholder}}</ng-template>
